// Generated by Melange

import * as Buhta_commonapis__Buhta_common_v1_bank from "../../commonapis/gen/buhta_common_v1_bank.js";
import * as Buhta_commonapis__Buhta_common_v1_country from "../../commonapis/gen/buhta_common_v1_country.js";
import * as Buhta_commonapis__Buhta_common_v1_org_type from "../../commonapis/gen/buhta_common_v1_org_type.js";
import * as Caml_module from "melange.js/caml_module.js";
import * as Curry from "melange.js/curry.js";
import * as Google_type__Google_type_date from "../../third_party/google_type/gen/google_type_date.js";
import * as Ocaml_protoc_plugin from "../../../vendored/ocaml_protoc_plugin/ocaml_protoc_plugin.js";
import * as Ocaml_protoc_plugin__Deserialize from "../../../vendored/ocaml_protoc_plugin/deserialize.js";
import * as Ocaml_protoc_plugin__Deserialize_json from "../../../vendored/ocaml_protoc_plugin/deserialize_json.js";
import * as Ocaml_protoc_plugin__Merge from "../../../vendored/ocaml_protoc_plugin/merge.js";
import * as Ocaml_protoc_plugin__Result from "../../../vendored/ocaml_protoc_plugin/result.js";
import * as Ocaml_protoc_plugin__Serialize from "../../../vendored/ocaml_protoc_plugin/serialize.js";
import * as Ocaml_protoc_plugin__Serialize_json from "../../../vendored/ocaml_protoc_plugin/serialize_json.js";
import * as Ocaml_protoc_plugin__Spec from "../../../vendored/ocaml_protoc_plugin/spec.js";
import * as Ocaml_protoc_plugin__Writer from "../../../vendored/ocaml_protoc_plugin/writer.js";

const Imported$pmodules = {};

const Buhta = Caml_module.init_mod([
      "proto/controlapis/gen/buhta_control_v1alpha1_entity_lookup.ml",
      274,
      6
    ], {
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "to_int"
                          ],
                          [
                            /* Function */0,
                            "from_int"
                          ],
                          [
                            /* Function */0,
                            "from_int_exn"
                          ],
                          [
                            /* Function */0,
                            "to_string"
                          ],
                          [
                            /* Function */0,
                            "from_string_exn"
                          ]
                        ]
                      },
                      "LookupCtx"
                    ],
                    [
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "make"
                          ],
                          [
                            /* Function */0,
                            "to_proto"
                          ],
                          [
                            /* Function */0,
                            "from_proto"
                          ],
                          [
                            /* Function */0,
                            "to_json"
                          ],
                          [
                            /* Function */0,
                            "from_json"
                          ],
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "merge"
                          ],
                          [
                            /* Function */0,
                            "to_proto$p"
                          ],
                          [
                            /* Function */0,
                            "from_proto_exn"
                          ],
                          [
                            /* Function */0,
                            "from_json_exn"
                          ]
                        ]
                      },
                      "EntityLookupPerson"
                    ],
                    [
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            {
                              TAG: /* Module */0,
                              _0: [
                                [
                                  /* Function */0,
                                  "make"
                                ],
                                [
                                  /* Function */0,
                                  "to_proto"
                                ],
                                [
                                  /* Function */0,
                                  "from_proto"
                                ],
                                [
                                  /* Function */0,
                                  "to_json"
                                ],
                                [
                                  /* Function */0,
                                  "from_json"
                                ],
                                [
                                  /* Function */0,
                                  "name"
                                ],
                                [
                                  /* Function */0,
                                  "merge"
                                ],
                                [
                                  /* Function */0,
                                  "to_proto$p"
                                ],
                                [
                                  /* Function */0,
                                  "from_proto_exn"
                                ],
                                [
                                  /* Function */0,
                                  "from_json_exn"
                                ]
                              ]
                            },
                            "LookupChief"
                          ],
                          [
                            {
                              TAG: /* Module */0,
                              _0: [
                                [
                                  {
                                    TAG: /* Module */0,
                                    _0: [
                                      [
                                        /* Function */0,
                                        "make"
                                      ],
                                      [
                                        /* Function */0,
                                        "to_proto"
                                      ],
                                      [
                                        /* Function */0,
                                        "from_proto"
                                      ],
                                      [
                                        /* Function */0,
                                        "to_json"
                                      ],
                                      [
                                        /* Function */0,
                                        "from_json"
                                      ],
                                      [
                                        /* Function */0,
                                        "name"
                                      ],
                                      [
                                        /* Function */0,
                                        "merge"
                                      ],
                                      [
                                        /* Function */0,
                                        "to_proto$p"
                                      ],
                                      [
                                        /* Function */0,
                                        "from_proto_exn"
                                      ],
                                      [
                                        /* Function */0,
                                        "from_json_exn"
                                      ]
                                    ]
                                  },
                                  "Vat"
                                ],
                                [
                                  /* Function */0,
                                  "make"
                                ],
                                [
                                  /* Function */0,
                                  "to_proto"
                                ],
                                [
                                  /* Function */0,
                                  "from_proto"
                                ],
                                [
                                  /* Function */0,
                                  "to_json"
                                ],
                                [
                                  /* Function */0,
                                  "from_json"
                                ],
                                [
                                  /* Function */0,
                                  "name"
                                ],
                                [
                                  /* Function */0,
                                  "merge"
                                ],
                                [
                                  /* Function */0,
                                  "to_proto$p"
                                ],
                                [
                                  /* Function */0,
                                  "from_proto_exn"
                                ],
                                [
                                  /* Function */0,
                                  "from_json_exn"
                                ]
                              ]
                            },
                            "LookupTax"
                          ],
                          [
                            {
                              TAG: /* Module */0,
                              _0: [
                                [
                                  /* Function */0,
                                  "make"
                                ],
                                [
                                  /* Function */0,
                                  "to_proto"
                                ],
                                [
                                  /* Function */0,
                                  "from_proto"
                                ],
                                [
                                  /* Function */0,
                                  "to_json"
                                ],
                                [
                                  /* Function */0,
                                  "from_json"
                                ],
                                [
                                  /* Function */0,
                                  "name"
                                ],
                                [
                                  /* Function */0,
                                  "merge"
                                ],
                                [
                                  /* Function */0,
                                  "to_proto$p"
                                ],
                                [
                                  /* Function */0,
                                  "from_proto_exn"
                                ],
                                [
                                  /* Function */0,
                                  "from_json_exn"
                                ]
                              ]
                            },
                            "LookupBankAccount"
                          ],
                          [
                            /* Function */0,
                            "make"
                          ],
                          [
                            /* Function */0,
                            "to_proto"
                          ],
                          [
                            /* Function */0,
                            "from_proto"
                          ],
                          [
                            /* Function */0,
                            "to_json"
                          ],
                          [
                            /* Function */0,
                            "from_json"
                          ],
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "merge"
                          ],
                          [
                            /* Function */0,
                            "to_proto$p"
                          ],
                          [
                            /* Function */0,
                            "from_proto_exn"
                          ],
                          [
                            /* Function */0,
                            "from_json_exn"
                          ]
                        ]
                      },
                      "EntityLookupOrg"
                    ]
                  ]
                },
                "V1alpha1"
              ]]
          },
          "Control"
        ]]
    });

const Control = Caml_module.init_mod([
      "proto/controlapis/gen/buhta_control_v1alpha1_entity_lookup.ml",
      509,
      8
    ], {
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "to_int"
                    ],
                    [
                      /* Function */0,
                      "from_int"
                    ],
                    [
                      /* Function */0,
                      "from_int_exn"
                    ],
                    [
                      /* Function */0,
                      "to_string"
                    ],
                    [
                      /* Function */0,
                      "from_string_exn"
                    ]
                  ]
                },
                "LookupCtx"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "EntityLookupPerson"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "make"
                          ],
                          [
                            /* Function */0,
                            "to_proto"
                          ],
                          [
                            /* Function */0,
                            "from_proto"
                          ],
                          [
                            /* Function */0,
                            "to_json"
                          ],
                          [
                            /* Function */0,
                            "from_json"
                          ],
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "merge"
                          ],
                          [
                            /* Function */0,
                            "to_proto$p"
                          ],
                          [
                            /* Function */0,
                            "from_proto_exn"
                          ],
                          [
                            /* Function */0,
                            "from_json_exn"
                          ]
                        ]
                      },
                      "LookupChief"
                    ],
                    [
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            {
                              TAG: /* Module */0,
                              _0: [
                                [
                                  /* Function */0,
                                  "make"
                                ],
                                [
                                  /* Function */0,
                                  "to_proto"
                                ],
                                [
                                  /* Function */0,
                                  "from_proto"
                                ],
                                [
                                  /* Function */0,
                                  "to_json"
                                ],
                                [
                                  /* Function */0,
                                  "from_json"
                                ],
                                [
                                  /* Function */0,
                                  "name"
                                ],
                                [
                                  /* Function */0,
                                  "merge"
                                ],
                                [
                                  /* Function */0,
                                  "to_proto$p"
                                ],
                                [
                                  /* Function */0,
                                  "from_proto_exn"
                                ],
                                [
                                  /* Function */0,
                                  "from_json_exn"
                                ]
                              ]
                            },
                            "Vat"
                          ],
                          [
                            /* Function */0,
                            "make"
                          ],
                          [
                            /* Function */0,
                            "to_proto"
                          ],
                          [
                            /* Function */0,
                            "from_proto"
                          ],
                          [
                            /* Function */0,
                            "to_json"
                          ],
                          [
                            /* Function */0,
                            "from_json"
                          ],
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "merge"
                          ],
                          [
                            /* Function */0,
                            "to_proto$p"
                          ],
                          [
                            /* Function */0,
                            "from_proto_exn"
                          ],
                          [
                            /* Function */0,
                            "from_json_exn"
                          ]
                        ]
                      },
                      "LookupTax"
                    ],
                    [
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "make"
                          ],
                          [
                            /* Function */0,
                            "to_proto"
                          ],
                          [
                            /* Function */0,
                            "from_proto"
                          ],
                          [
                            /* Function */0,
                            "to_json"
                          ],
                          [
                            /* Function */0,
                            "from_json"
                          ],
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "merge"
                          ],
                          [
                            /* Function */0,
                            "to_proto$p"
                          ],
                          [
                            /* Function */0,
                            "from_proto_exn"
                          ],
                          [
                            /* Function */0,
                            "from_json_exn"
                          ]
                        ]
                      },
                      "LookupBankAccount"
                    ],
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "EntityLookupOrg"
              ]
            ]
          },
          "V1alpha1"
        ]]
    });

const V1alpha1 = Caml_module.init_mod([
      "proto/controlapis/gen/buhta_control_v1alpha1_entity_lookup.ml",
      742,
      10
    ], {
      TAG: /* Module */0,
      _0: [
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "to_int"
              ],
              [
                /* Function */0,
                "from_int"
              ],
              [
                /* Function */0,
                "from_int_exn"
              ],
              [
                /* Function */0,
                "to_string"
              ],
              [
                /* Function */0,
                "from_string_exn"
              ]
            ]
          },
          "LookupCtx"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "EntityLookupPerson"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "LookupChief"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "make"
                          ],
                          [
                            /* Function */0,
                            "to_proto"
                          ],
                          [
                            /* Function */0,
                            "from_proto"
                          ],
                          [
                            /* Function */0,
                            "to_json"
                          ],
                          [
                            /* Function */0,
                            "from_json"
                          ],
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "merge"
                          ],
                          [
                            /* Function */0,
                            "to_proto$p"
                          ],
                          [
                            /* Function */0,
                            "from_proto_exn"
                          ],
                          [
                            /* Function */0,
                            "from_json_exn"
                          ]
                        ]
                      },
                      "Vat"
                    ],
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "LookupTax"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "LookupBankAccount"
              ],
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "EntityLookupOrg"
        ]
      ]
    });

const LookupCtx = Caml_module.init_mod([
      "proto/controlapis/gen/buhta_control_v1alpha1_entity_lookup.ml",
      760,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "to_int"
        ],
        [
          /* Function */0,
          "from_int"
        ],
        [
          /* Function */0,
          "from_int_exn"
        ],
        [
          /* Function */0,
          "to_string"
        ],
        [
          /* Function */0,
          "from_string_exn"
        ]
      ]
    });

const EntityLookupPerson = Caml_module.init_mod([
      "proto/controlapis/gen/buhta_control_v1alpha1_entity_lookup.ml",
      830,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const EntityLookupOrg = Caml_module.init_mod([
      "proto/controlapis/gen/buhta_control_v1alpha1_entity_lookup.ml",
      1055,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "LookupChief"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "Vat"
              ],
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "LookupTax"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "LookupBankAccount"
        ],
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

function name(param) {
  return ".buhta.control.v1alpha1.LookupCtx";
}

function to_int(param) {
  return param;
}

function from_int_exn(n) {
  if (n > 3 || n < 0) {
    return Ocaml_protoc_plugin__Result.raise({
                NAME: "Unknown_enum_value",
                VAL: n
              });
  } else {
    return n;
  }
}

function from_int(e) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return from_int_exn(e);
            });
}

function to_string(param) {
  switch (param) {
    case /* LOOKUP_CTX_UNSPECIFIED */0 :
        return "LOOKUP_CTX_UNSPECIFIED";
    case /* LOOKUP_CTX_ORG */1 :
        return "LOOKUP_CTX_ORG";
    case /* LOOKUP_CTX_EMPLOYEE */2 :
        return "LOOKUP_CTX_EMPLOYEE";
    case /* LOOKUP_CTX_CONTRACTOR */3 :
        return "LOOKUP_CTX_CONTRACTOR";
    
  }
}

function from_string_exn(s) {
  switch (s) {
    case "LOOKUP_CTX_CONTRACTOR" :
        return /* LOOKUP_CTX_CONTRACTOR */3;
    case "LOOKUP_CTX_EMPLOYEE" :
        return /* LOOKUP_CTX_EMPLOYEE */2;
    case "LOOKUP_CTX_ORG" :
        return /* LOOKUP_CTX_ORG */1;
    case "LOOKUP_CTX_UNSPECIFIED" :
        return /* LOOKUP_CTX_UNSPECIFIED */0;
    default:
      return Ocaml_protoc_plugin__Result.raise({
                  NAME: "Unknown_enum_name",
                  VAL: s
                });
  }
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "to_int"
        ],
        [
          /* Function */0,
          "from_int"
        ],
        [
          /* Function */0,
          "from_int_exn"
        ],
        [
          /* Function */0,
          "to_string"
        ],
        [
          /* Function */0,
          "from_string_exn"
        ]
      ]
    }, LookupCtx, {
      name: name,
      to_int: to_int,
      from_int: from_int,
      from_int_exn: from_int_exn,
      to_string: to_string,
      from_string_exn: from_string_exn
    });

function name$1(param) {
  return ".buhta.control.v1alpha1.EntityLookupPerson";
}

function make(countryOpt, tinOpt, family_nameOpt, given_nameOpt, patronymic_nameOpt, residentOpt, addressOpt, last_update_date, param) {
  const country = countryOpt !== undefined ? countryOpt : Curry._1(Buhta_commonapis__Buhta_common_v1_country.Buhta.Common.V1.Country.from_int_exn, 0);
  const tin = tinOpt !== undefined ? tinOpt : "";
  const family_name = family_nameOpt !== undefined ? family_nameOpt : "";
  const given_name = given_nameOpt !== undefined ? given_nameOpt : "";
  const patronymic_name = patronymic_nameOpt !== undefined ? patronymic_nameOpt : "";
  const resident = residentOpt !== undefined ? residentOpt : false;
  const address = addressOpt !== undefined ? addressOpt : "";
  return {
          country: country,
          tin: tin,
          family_name: family_name,
          given_name: given_name,
          patronymic_name: patronymic_name,
          resident: resident,
          address: address,
          last_update_date: last_update_date
        };
}

const merge_country = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            1,
            "country",
            "country"
          ],
          Ocaml_protoc_plugin__Spec.$$enum(Buhta_commonapis__Buhta_common_v1_country.Buhta.Common.V1.Country),
          Curry._1(Buhta_commonapis__Buhta_common_v1_country.Buhta.Common.V1.Country.from_int_exn, 0)
        ]));

const merge_tin = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            2,
            "tin",
            "tin"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_family_name = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            3,
            "family_name",
            "familyName"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_given_name = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            4,
            "given_name",
            "givenName"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_patronymic_name = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            5,
            "patronymic_name",
            "patronymicName"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_resident = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            6,
            "resident",
            "resident"
          ],
          Ocaml_protoc_plugin__Spec.bool,
          false
        ]));

const merge_address = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            7,
            "address",
            "address"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const $$let = Google_type__Google_type_date.Google.Type.$$Date;

const merge_last_update_date = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            11,
            "last_update_date",
            "lastUpdateDate"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let.name,
                make: $$let.make,
                from_proto: $$let.from_proto,
                from_proto_exn: $$let.from_proto_exn,
                to_proto: $$let.to_proto,
                to_proto$p: $$let.to_proto$p,
                merge: $$let.merge,
                to_json: $$let.to_json,
                from_json_exn: $$let.from_json_exn,
                from_json: $$let.from_json
              })
        ]));

function merge(t1, t2) {
  return {
          country: Curry._2(merge_country, t1.country, t2.country),
          tin: Curry._2(merge_tin, t1.tin, t2.tin),
          family_name: Curry._2(merge_family_name, t1.family_name, t2.family_name),
          given_name: Curry._2(merge_given_name, t1.given_name, t2.given_name),
          patronymic_name: Curry._2(merge_patronymic_name, t1.patronymic_name, t2.patronymic_name),
          resident: Curry._2(merge_resident, t1.resident, t2.resident),
          address: Curry._2(merge_address, t1.address, t2.address),
          last_update_date: Curry._2(merge_last_update_date, t1.last_update_date, t2.last_update_date)
        };
}

function spec(param) {
  const $$let = Google_type__Google_type_date.Google.Type.$$Date;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                  [
                    1,
                    "country",
                    "country"
                  ],
                  Ocaml_protoc_plugin__Spec.$$enum(Buhta_commonapis__Buhta_common_v1_country.Buhta.Common.V1.Country),
                  Curry._1(Buhta_commonapis__Buhta_common_v1_country.Buhta.Common.V1.Country.from_int_exn, 0)
                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                      [
                        2,
                        "tin",
                        "tin"
                      ],
                      Ocaml_protoc_plugin__Spec.string,
                      ""
                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                          [
                            3,
                            "family_name",
                            "familyName"
                          ],
                          Ocaml_protoc_plugin__Spec.string,
                          ""
                        ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                              [
                                4,
                                "given_name",
                                "givenName"
                              ],
                              Ocaml_protoc_plugin__Spec.string,
                              ""
                            ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                  [
                                    5,
                                    "patronymic_name",
                                    "patronymicName"
                                  ],
                                  Ocaml_protoc_plugin__Spec.string,
                                  ""
                                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                      [
                                        6,
                                        "resident",
                                        "resident"
                                      ],
                                      Ocaml_protoc_plugin__Spec.bool,
                                      false
                                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                          [
                                            7,
                                            "address",
                                            "address"
                                          ],
                                          Ocaml_protoc_plugin__Spec.string,
                                          ""
                                        ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                                              [
                                                11,
                                                "last_update_date",
                                                "lastUpdateDate"
                                              ],
                                              Ocaml_protoc_plugin__Spec.message({
                                                    name: $$let.name,
                                                    make: $$let.make,
                                                    from_proto: $$let.from_proto,
                                                    from_proto_exn: $$let.from_proto_exn,
                                                    to_proto: $$let.to_proto,
                                                    to_proto$p: $$let.to_proto$p,
                                                    merge: $$let.merge,
                                                    to_json: $$let.to_json,
                                                    from_json_exn: $$let.from_json_exn,
                                                    from_json: $$let.from_json
                                                  })
                                            ]), Ocaml_protoc_plugin__Spec.nil))))))));
}

const serialize = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec(undefined));
    });

function to_proto$p(writer, param) {
  Curry.app(serialize, [
        writer,
        param.country,
        param.tin,
        param.family_name,
        param.given_name,
        param.patronymic_name,
        param.resident,
        param.address,
        param.last_update_date
      ]);
}

function to_proto(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p(writer, t);
  return writer;
}

function constructor(country, tin, family_name, given_name, patronymic_name, resident, address, last_update_date) {
  return {
          country: country,
          tin: tin,
          family_name: family_name,
          given_name: given_name,
          patronymic_name: patronymic_name,
          resident: resident,
          address: address,
          last_update_date: last_update_date
        };
}

const from_proto_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec(undefined), constructor);
    });

function from_proto(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn, writer);
            });
}

function to_json(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.control.v1alpha1.EntityLookupPerson", spec(undefined))(options);
  return function (param) {
    return Curry._8(serialize, param.country, param.tin, param.family_name, param.given_name, param.patronymic_name, param.resident, param.address, param.last_update_date);
  };
}

function constructor$1(country, tin, family_name, given_name, patronymic_name, resident, address, last_update_date) {
  return {
          country: country,
          tin: tin,
          family_name: family_name,
          given_name: given_name,
          patronymic_name: patronymic_name,
          resident: resident,
          address: address,
          last_update_date: last_update_date
        };
}

const from_json_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.control.v1alpha1.EntityLookupPerson", spec(undefined), constructor$1);
    });

function from_json(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, EntityLookupPerson, {
      make: make,
      to_proto: to_proto,
      from_proto: from_proto,
      to_json: to_json,
      from_json: from_json,
      name: name$1,
      merge: merge,
      to_proto$p: to_proto$p,
      from_proto_exn: from_proto_exn,
      from_json_exn: from_json_exn
    });

const LookupChief = Caml_module.init_mod([
      "proto/controlapis/gen/buhta_control_v1alpha1_entity_lookup.ml",
      1090,
      14
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const LookupTax = Caml_module.init_mod([
      "proto/controlapis/gen/buhta_control_v1alpha1_entity_lookup.ml",
      1194,
      14
    ], {
      TAG: /* Module */0,
      _0: [
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "Vat"
        ],
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const LookupBankAccount = Caml_module.init_mod([
      "proto/controlapis/gen/buhta_control_v1alpha1_entity_lookup.ml",
      1324,
      14
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

function name$2(param) {
  return ".buhta.control.v1alpha1.EntityLookupOrg.LookupChief";
}

function make$1(tinOpt, residentOpt, family_nameOpt, given_nameOpt, patronymic_nameOpt, param) {
  const tin = tinOpt !== undefined ? tinOpt : "";
  const resident = residentOpt !== undefined ? residentOpt : false;
  const family_name = family_nameOpt !== undefined ? family_nameOpt : "";
  const given_name = given_nameOpt !== undefined ? given_nameOpt : "";
  const patronymic_name = patronymic_nameOpt !== undefined ? patronymic_nameOpt : "";
  return {
          tin: tin,
          resident: resident,
          family_name: family_name,
          given_name: given_name,
          patronymic_name: patronymic_name
        };
}

const merge_tin$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            1,
            "tin",
            "tin"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_resident$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            2,
            "resident",
            "resident"
          ],
          Ocaml_protoc_plugin__Spec.bool,
          false
        ]));

const merge_family_name$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            3,
            "family_name",
            "familyName"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_given_name$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            4,
            "given_name",
            "givenName"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_patronymic_name$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            5,
            "patronymic_name",
            "patronymicName"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

function merge$1(t1, t2) {
  return {
          tin: Curry._2(merge_tin$1, t1.tin, t2.tin),
          resident: Curry._2(merge_resident$1, t1.resident, t2.resident),
          family_name: Curry._2(merge_family_name$1, t1.family_name, t2.family_name),
          given_name: Curry._2(merge_given_name$1, t1.given_name, t2.given_name),
          patronymic_name: Curry._2(merge_patronymic_name$1, t1.patronymic_name, t2.patronymic_name)
        };
}

function spec$1(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                  [
                    1,
                    "tin",
                    "tin"
                  ],
                  Ocaml_protoc_plugin__Spec.string,
                  ""
                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                      [
                        2,
                        "resident",
                        "resident"
                      ],
                      Ocaml_protoc_plugin__Spec.bool,
                      false
                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                          [
                            3,
                            "family_name",
                            "familyName"
                          ],
                          Ocaml_protoc_plugin__Spec.string,
                          ""
                        ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                              [
                                4,
                                "given_name",
                                "givenName"
                              ],
                              Ocaml_protoc_plugin__Spec.string,
                              ""
                            ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                  [
                                    5,
                                    "patronymic_name",
                                    "patronymicName"
                                  ],
                                  Ocaml_protoc_plugin__Spec.string,
                                  ""
                                ]), Ocaml_protoc_plugin__Spec.nil)))));
}

const serialize$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$1(undefined));
    });

function to_proto$p$1(writer, param) {
  Curry._6(serialize$1, writer, param.tin, param.resident, param.family_name, param.given_name, param.patronymic_name);
}

function to_proto$1(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$1(writer, t);
  return writer;
}

function constructor$2(tin, resident, family_name, given_name, patronymic_name) {
  return {
          tin: tin,
          resident: resident,
          family_name: family_name,
          given_name: given_name,
          patronymic_name: patronymic_name
        };
}

const from_proto_exn$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$1(undefined), constructor$2);
    });

function from_proto$1(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$1, writer);
            });
}

function to_json$1(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.control.v1alpha1.EntityLookupOrg.LookupChief", spec$1(undefined))(options);
  return function (param) {
    return Curry._5(serialize, param.tin, param.resident, param.family_name, param.given_name, param.patronymic_name);
  };
}

function constructor$3(tin, resident, family_name, given_name, patronymic_name) {
  return {
          tin: tin,
          resident: resident,
          family_name: family_name,
          given_name: given_name,
          patronymic_name: patronymic_name
        };
}

const from_json_exn$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.control.v1alpha1.EntityLookupOrg.LookupChief", spec$1(undefined), constructor$3);
    });

function from_json$1(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$1, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, LookupChief, {
      make: make$1,
      to_proto: to_proto$1,
      from_proto: from_proto$1,
      to_json: to_json$1,
      from_json: from_json$1,
      name: name$2,
      merge: merge$1,
      to_proto$p: to_proto$p$1,
      from_proto_exn: from_proto_exn$1,
      from_json_exn: from_json_exn$1
    });

const Vat = Caml_module.init_mod([
      "proto/controlapis/gen/buhta_control_v1alpha1_entity_lookup.ml",
      1226,
      16
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

function name$3(param) {
  return ".buhta.control.v1alpha1.EntityLookupOrg.LookupTax.Vat";
}

function make$2(vat_seriesOpt, vat_numberOpt, param) {
  const vat_series = vat_seriesOpt !== undefined ? vat_seriesOpt : "";
  const vat_number = vat_numberOpt !== undefined ? vat_numberOpt : "";
  return {
          vat_series: vat_series,
          vat_number: vat_number
        };
}

const merge_vat_series = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            1,
            "vat_series",
            "vatSeries"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_vat_number = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            2,
            "vat_number",
            "vatNumber"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

function merge$2(t1, t2) {
  return {
          vat_series: Curry._2(merge_vat_series, t1.vat_series, t2.vat_series),
          vat_number: Curry._2(merge_vat_number, t1.vat_number, t2.vat_number)
        };
}

function spec$2(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                  [
                    1,
                    "vat_series",
                    "vatSeries"
                  ],
                  Ocaml_protoc_plugin__Spec.string,
                  ""
                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                      [
                        2,
                        "vat_number",
                        "vatNumber"
                      ],
                      Ocaml_protoc_plugin__Spec.string,
                      ""
                    ]), Ocaml_protoc_plugin__Spec.nil));
}

const serialize$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$2(undefined));
    });

function to_proto$p$2(writer, param) {
  Curry._3(serialize$2, writer, param.vat_series, param.vat_number);
}

function to_proto$2(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$2(writer, t);
  return writer;
}

function constructor$4(vat_series, vat_number) {
  return {
          vat_series: vat_series,
          vat_number: vat_number
        };
}

const from_proto_exn$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$2(undefined), constructor$4);
    });

function from_proto$2(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$2, writer);
            });
}

function to_json$2(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.control.v1alpha1.EntityLookupOrg.LookupTax.Vat", spec$2(undefined))(options);
  return function (param) {
    return Curry._2(serialize, param.vat_series, param.vat_number);
  };
}

function constructor$5(vat_series, vat_number) {
  return {
          vat_series: vat_series,
          vat_number: vat_number
        };
}

const from_json_exn$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.control.v1alpha1.EntityLookupOrg.LookupTax.Vat", spec$2(undefined), constructor$5);
    });

function from_json$2(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$2, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, Vat, {
      make: make$2,
      to_proto: to_proto$2,
      from_proto: from_proto$2,
      to_json: to_json$2,
      from_json: from_json$2,
      name: name$3,
      merge: merge$2,
      to_proto$p: to_proto$p$2,
      from_proto_exn: from_proto_exn$2,
      from_json_exn: from_json_exn$2
    });

function name$4(param) {
  return ".buhta.control.v1alpha1.EntityLookupOrg.LookupTax";
}

function make$3(kogdOpt, vat, param) {
  const kogd = kogdOpt !== undefined ? kogdOpt : "";
  return {
          kogd: kogd,
          vat: vat
        };
}

const merge_kogd = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            1,
            "kogd",
            "kogd"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_vat = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            2,
            "vat",
            "vat"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: Vat.name,
                make: Vat.make,
                from_proto: Vat.from_proto,
                from_proto_exn: Vat.from_proto_exn,
                to_proto: Vat.to_proto,
                to_proto$p: Vat.to_proto$p,
                merge: Vat.merge,
                to_json: Vat.to_json,
                from_json_exn: Vat.from_json_exn,
                from_json: Vat.from_json
              })
        ]));

function merge$3(t1, t2) {
  return {
          kogd: Curry._2(merge_kogd, t1.kogd, t2.kogd),
          vat: Curry._2(merge_vat, t1.vat, t2.vat)
        };
}

function spec$3(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                  [
                    1,
                    "kogd",
                    "kogd"
                  ],
                  Ocaml_protoc_plugin__Spec.string,
                  ""
                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                      [
                        2,
                        "vat",
                        "vat"
                      ],
                      Ocaml_protoc_plugin__Spec.message({
                            name: Vat.name,
                            make: Vat.make,
                            from_proto: Vat.from_proto,
                            from_proto_exn: Vat.from_proto_exn,
                            to_proto: Vat.to_proto,
                            to_proto$p: Vat.to_proto$p,
                            merge: Vat.merge,
                            to_json: Vat.to_json,
                            from_json_exn: Vat.from_json_exn,
                            from_json: Vat.from_json
                          })
                    ]), Ocaml_protoc_plugin__Spec.nil));
}

const serialize$3 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$3(undefined));
    });

function to_proto$p$3(writer, param) {
  Curry._3(serialize$3, writer, param.kogd, param.vat);
}

function to_proto$3(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$3(writer, t);
  return writer;
}

function constructor$6(kogd, vat) {
  return {
          kogd: kogd,
          vat: vat
        };
}

const from_proto_exn$3 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$3(undefined), constructor$6);
    });

function from_proto$3(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$3, writer);
            });
}

function to_json$3(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.control.v1alpha1.EntityLookupOrg.LookupTax", spec$3(undefined))(options);
  return function (param) {
    return Curry._2(serialize, param.kogd, param.vat);
  };
}

function constructor$7(kogd, vat) {
  return {
          kogd: kogd,
          vat: vat
        };
}

const from_json_exn$3 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.control.v1alpha1.EntityLookupOrg.LookupTax", spec$3(undefined), constructor$7);
    });

function from_json$3(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$3, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "Vat"
        ],
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, LookupTax, {
      Vat: Vat,
      make: make$3,
      to_proto: to_proto$3,
      from_proto: from_proto$3,
      to_json: to_json$3,
      from_json: from_json$3,
      name: name$4,
      merge: merge$3,
      to_proto$p: to_proto$p$3,
      from_proto_exn: from_proto_exn$3,
      from_json_exn: from_json_exn$3
    });

function name$5(param) {
  return ".buhta.control.v1alpha1.EntityLookupOrg.LookupBankAccount";
}

function make$4(ibanOpt, bicOpt, bank, open_date, param) {
  const iban = ibanOpt !== undefined ? ibanOpt : "";
  const bic = bicOpt !== undefined ? bicOpt : "";
  return {
          iban: iban,
          bic: bic,
          bank: bank,
          open_date: open_date
        };
}

const merge_iban = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            1,
            "iban",
            "iban"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_bic = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            2,
            "bic",
            "bic"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const $$let$1 = Buhta_commonapis__Buhta_common_v1_bank.Buhta.Common.V1.Bank;

const merge_bank = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            3,
            "bank",
            "bank"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$1.name,
                make: $$let$1.make,
                from_proto: $$let$1.from_proto,
                from_proto_exn: $$let$1.from_proto_exn,
                to_proto: $$let$1.to_proto,
                to_proto$p: $$let$1.to_proto$p,
                merge: $$let$1.merge,
                to_json: $$let$1.to_json,
                from_json_exn: $$let$1.from_json_exn,
                from_json: $$let$1.from_json
              })
        ]));

const $$let$2 = Google_type__Google_type_date.Google.Type.$$Date;

const merge_open_date = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            4,
            "open_date",
            "openDate"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$2.name,
                make: $$let$2.make,
                from_proto: $$let$2.from_proto,
                from_proto_exn: $$let$2.from_proto_exn,
                to_proto: $$let$2.to_proto,
                to_proto$p: $$let$2.to_proto$p,
                merge: $$let$2.merge,
                to_json: $$let$2.to_json,
                from_json_exn: $$let$2.from_json_exn,
                from_json: $$let$2.from_json
              })
        ]));

function merge$4(t1, t2) {
  return {
          iban: Curry._2(merge_iban, t1.iban, t2.iban),
          bic: Curry._2(merge_bic, t1.bic, t2.bic),
          bank: Curry._2(merge_bank, t1.bank, t2.bank),
          open_date: Curry._2(merge_open_date, t1.open_date, t2.open_date)
        };
}

function spec$4(param) {
  const $$let = Buhta_commonapis__Buhta_common_v1_bank.Buhta.Common.V1.Bank;
  const $$let$1 = Google_type__Google_type_date.Google.Type.$$Date;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                  [
                    1,
                    "iban",
                    "iban"
                  ],
                  Ocaml_protoc_plugin__Spec.string,
                  ""
                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                      [
                        2,
                        "bic",
                        "bic"
                      ],
                      Ocaml_protoc_plugin__Spec.string,
                      ""
                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                          [
                            3,
                            "bank",
                            "bank"
                          ],
                          Ocaml_protoc_plugin__Spec.message({
                                name: $$let.name,
                                make: $$let.make,
                                from_proto: $$let.from_proto,
                                from_proto_exn: $$let.from_proto_exn,
                                to_proto: $$let.to_proto,
                                to_proto$p: $$let.to_proto$p,
                                merge: $$let.merge,
                                to_json: $$let.to_json,
                                from_json_exn: $$let.from_json_exn,
                                from_json: $$let.from_json
                              })
                        ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                              [
                                4,
                                "open_date",
                                "openDate"
                              ],
                              Ocaml_protoc_plugin__Spec.message({
                                    name: $$let$1.name,
                                    make: $$let$1.make,
                                    from_proto: $$let$1.from_proto,
                                    from_proto_exn: $$let$1.from_proto_exn,
                                    to_proto: $$let$1.to_proto,
                                    to_proto$p: $$let$1.to_proto$p,
                                    merge: $$let$1.merge,
                                    to_json: $$let$1.to_json,
                                    from_json_exn: $$let$1.from_json_exn,
                                    from_json: $$let$1.from_json
                                  })
                            ]), Ocaml_protoc_plugin__Spec.nil))));
}

const serialize$4 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$4(undefined));
    });

function to_proto$p$4(writer, param) {
  Curry._5(serialize$4, writer, param.iban, param.bic, param.bank, param.open_date);
}

function to_proto$4(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$4(writer, t);
  return writer;
}

function constructor$8(iban, bic, bank, open_date) {
  return {
          iban: iban,
          bic: bic,
          bank: bank,
          open_date: open_date
        };
}

const from_proto_exn$4 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$4(undefined), constructor$8);
    });

function from_proto$4(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$4, writer);
            });
}

function to_json$4(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.control.v1alpha1.EntityLookupOrg.LookupBankAccount", spec$4(undefined))(options);
  return function (param) {
    return Curry._4(serialize, param.iban, param.bic, param.bank, param.open_date);
  };
}

function constructor$9(iban, bic, bank, open_date) {
  return {
          iban: iban,
          bic: bic,
          bank: bank,
          open_date: open_date
        };
}

const from_json_exn$4 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.control.v1alpha1.EntityLookupOrg.LookupBankAccount", spec$4(undefined), constructor$9);
    });

function from_json$4(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$4, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, LookupBankAccount, {
      make: make$4,
      to_proto: to_proto$4,
      from_proto: from_proto$4,
      to_json: to_json$4,
      from_json: from_json$4,
      name: name$5,
      merge: merge$4,
      to_proto$p: to_proto$p$4,
      from_proto_exn: from_proto_exn$4,
      from_json_exn: from_json_exn$4
    });

function name$6(param) {
  return ".buhta.control.v1alpha1.EntityLookupOrg";
}

function make$5(countryOpt, type$pOpt, tinOpt, nameOpt, residentOpt, addressOpt, chief, tax, bank_accountsOpt, last_update_date, blockedOpt, block_reasonOpt, param) {
  const country = countryOpt !== undefined ? countryOpt : Curry._1(Buhta_commonapis__Buhta_common_v1_country.Buhta.Common.V1.Country.from_int_exn, 0);
  const type$p = type$pOpt !== undefined ? type$pOpt : Curry._1(Buhta_commonapis__Buhta_common_v1_org_type.Buhta.Common.V1.OrgType.from_int_exn, 0);
  const tin = tinOpt !== undefined ? tinOpt : "";
  const name = nameOpt !== undefined ? nameOpt : "";
  const resident = residentOpt !== undefined ? residentOpt : false;
  const address = addressOpt !== undefined ? addressOpt : "";
  const bank_accounts = bank_accountsOpt !== undefined ? bank_accountsOpt : /* [] */0;
  const blocked = blockedOpt !== undefined ? blockedOpt : false;
  const block_reason = block_reasonOpt !== undefined ? block_reasonOpt : "";
  return {
          country: country,
          "type'": type$p,
          tin: tin,
          name: name,
          resident: resident,
          address: address,
          chief: chief,
          tax: tax,
          bank_accounts: bank_accounts,
          last_update_date: last_update_date,
          blocked: blocked,
          block_reason: block_reason
        };
}

const merge_country$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            1,
            "country",
            "country"
          ],
          Ocaml_protoc_plugin__Spec.$$enum(Buhta_commonapis__Buhta_common_v1_country.Buhta.Common.V1.Country),
          Curry._1(Buhta_commonapis__Buhta_common_v1_country.Buhta.Common.V1.Country.from_int_exn, 0)
        ]));

const merge_type$p = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            2,
            "type",
            "type"
          ],
          Ocaml_protoc_plugin__Spec.$$enum(Buhta_commonapis__Buhta_common_v1_org_type.Buhta.Common.V1.OrgType),
          Curry._1(Buhta_commonapis__Buhta_common_v1_org_type.Buhta.Common.V1.OrgType.from_int_exn, 0)
        ]));

const merge_tin$2 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            3,
            "tin",
            "tin"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_name = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            4,
            "name",
            "name"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_resident$2 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            5,
            "resident",
            "resident"
          ],
          Ocaml_protoc_plugin__Spec.bool,
          false
        ]));

const merge_address$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            6,
            "address",
            "address"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_chief = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            7,
            "chief",
            "chief"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: LookupChief.name,
                make: LookupChief.make,
                from_proto: LookupChief.from_proto,
                from_proto_exn: LookupChief.from_proto_exn,
                to_proto: LookupChief.to_proto,
                to_proto$p: LookupChief.to_proto$p,
                merge: LookupChief.merge,
                to_json: LookupChief.to_json,
                from_json_exn: LookupChief.from_json_exn,
                from_json: LookupChief.from_json
              })
        ]));

const merge_tax = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            8,
            "tax",
            "tax"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: LookupTax.name,
                make: LookupTax.make,
                from_proto: LookupTax.from_proto,
                from_proto_exn: LookupTax.from_proto_exn,
                to_proto: LookupTax.to_proto,
                to_proto$p: LookupTax.to_proto$p,
                merge: LookupTax.merge,
                to_json: LookupTax.to_json,
                from_json_exn: LookupTax.from_json_exn,
                from_json: LookupTax.from_json
              })
        ]));

const merge_bank_accounts = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.repeated([
          [
            9,
            "bank_accounts",
            "bankAccounts"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: LookupBankAccount.name,
                make: LookupBankAccount.make,
                from_proto: LookupBankAccount.from_proto,
                from_proto_exn: LookupBankAccount.from_proto_exn,
                to_proto: LookupBankAccount.to_proto,
                to_proto$p: LookupBankAccount.to_proto$p,
                merge: LookupBankAccount.merge,
                to_json: LookupBankAccount.to_json,
                from_json_exn: LookupBankAccount.from_json_exn,
                from_json: LookupBankAccount.from_json
              }),
          Ocaml_protoc_plugin__Spec.not_packed
        ]));

const $$let$3 = Google_type__Google_type_date.Google.Type.$$Date;

const merge_last_update_date$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            10,
            "last_update_date",
            "lastUpdateDate"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$3.name,
                make: $$let$3.make,
                from_proto: $$let$3.from_proto,
                from_proto_exn: $$let$3.from_proto_exn,
                to_proto: $$let$3.to_proto,
                to_proto$p: $$let$3.to_proto$p,
                merge: $$let$3.merge,
                to_json: $$let$3.to_json,
                from_json_exn: $$let$3.from_json_exn,
                from_json: $$let$3.from_json
              })
        ]));

const merge_blocked = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            11,
            "blocked",
            "blocked"
          ],
          Ocaml_protoc_plugin__Spec.bool,
          false
        ]));

const merge_block_reason = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            12,
            "block_reason",
            "blockReason"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

function merge$5(t1, t2) {
  return {
          country: Curry._2(merge_country$1, t1.country, t2.country),
          "type'": Curry._2(merge_type$p, t1["type'"], t2["type'"]),
          tin: Curry._2(merge_tin$2, t1.tin, t2.tin),
          name: Curry._2(merge_name, t1.name, t2.name),
          resident: Curry._2(merge_resident$2, t1.resident, t2.resident),
          address: Curry._2(merge_address$1, t1.address, t2.address),
          chief: Curry._2(merge_chief, t1.chief, t2.chief),
          tax: Curry._2(merge_tax, t1.tax, t2.tax),
          bank_accounts: Curry._2(merge_bank_accounts, t1.bank_accounts, t2.bank_accounts),
          last_update_date: Curry._2(merge_last_update_date$1, t1.last_update_date, t2.last_update_date),
          blocked: Curry._2(merge_blocked, t1.blocked, t2.blocked),
          block_reason: Curry._2(merge_block_reason, t1.block_reason, t2.block_reason)
        };
}

function spec$5(param) {
  const $$let = Google_type__Google_type_date.Google.Type.$$Date;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                  [
                    1,
                    "country",
                    "country"
                  ],
                  Ocaml_protoc_plugin__Spec.$$enum(Buhta_commonapis__Buhta_common_v1_country.Buhta.Common.V1.Country),
                  Curry._1(Buhta_commonapis__Buhta_common_v1_country.Buhta.Common.V1.Country.from_int_exn, 0)
                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                      [
                        2,
                        "type",
                        "type"
                      ],
                      Ocaml_protoc_plugin__Spec.$$enum(Buhta_commonapis__Buhta_common_v1_org_type.Buhta.Common.V1.OrgType),
                      Curry._1(Buhta_commonapis__Buhta_common_v1_org_type.Buhta.Common.V1.OrgType.from_int_exn, 0)
                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                          [
                            3,
                            "tin",
                            "tin"
                          ],
                          Ocaml_protoc_plugin__Spec.string,
                          ""
                        ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                              [
                                4,
                                "name",
                                "name"
                              ],
                              Ocaml_protoc_plugin__Spec.string,
                              ""
                            ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                  [
                                    5,
                                    "resident",
                                    "resident"
                                  ],
                                  Ocaml_protoc_plugin__Spec.bool,
                                  false
                                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                      [
                                        6,
                                        "address",
                                        "address"
                                      ],
                                      Ocaml_protoc_plugin__Spec.string,
                                      ""
                                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                                          [
                                            7,
                                            "chief",
                                            "chief"
                                          ],
                                          Ocaml_protoc_plugin__Spec.message({
                                                name: LookupChief.name,
                                                make: LookupChief.make,
                                                from_proto: LookupChief.from_proto,
                                                from_proto_exn: LookupChief.from_proto_exn,
                                                to_proto: LookupChief.to_proto,
                                                to_proto$p: LookupChief.to_proto$p,
                                                merge: LookupChief.merge,
                                                to_json: LookupChief.to_json,
                                                from_json_exn: LookupChief.from_json_exn,
                                                from_json: LookupChief.from_json
                                              })
                                        ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                                              [
                                                8,
                                                "tax",
                                                "tax"
                                              ],
                                              Ocaml_protoc_plugin__Spec.message({
                                                    name: LookupTax.name,
                                                    make: LookupTax.make,
                                                    from_proto: LookupTax.from_proto,
                                                    from_proto_exn: LookupTax.from_proto_exn,
                                                    to_proto: LookupTax.to_proto,
                                                    to_proto$p: LookupTax.to_proto$p,
                                                    merge: LookupTax.merge,
                                                    to_json: LookupTax.to_json,
                                                    from_json_exn: LookupTax.from_json_exn,
                                                    from_json: LookupTax.from_json
                                                  })
                                            ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.repeated([
                                                  [
                                                    9,
                                                    "bank_accounts",
                                                    "bankAccounts"
                                                  ],
                                                  Ocaml_protoc_plugin__Spec.message({
                                                        name: LookupBankAccount.name,
                                                        make: LookupBankAccount.make,
                                                        from_proto: LookupBankAccount.from_proto,
                                                        from_proto_exn: LookupBankAccount.from_proto_exn,
                                                        to_proto: LookupBankAccount.to_proto,
                                                        to_proto$p: LookupBankAccount.to_proto$p,
                                                        merge: LookupBankAccount.merge,
                                                        to_json: LookupBankAccount.to_json,
                                                        from_json_exn: LookupBankAccount.from_json_exn,
                                                        from_json: LookupBankAccount.from_json
                                                      }),
                                                  Ocaml_protoc_plugin__Spec.not_packed
                                                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                                                      [
                                                        10,
                                                        "last_update_date",
                                                        "lastUpdateDate"
                                                      ],
                                                      Ocaml_protoc_plugin__Spec.message({
                                                            name: $$let.name,
                                                            make: $$let.make,
                                                            from_proto: $$let.from_proto,
                                                            from_proto_exn: $$let.from_proto_exn,
                                                            to_proto: $$let.to_proto,
                                                            to_proto$p: $$let.to_proto$p,
                                                            merge: $$let.merge,
                                                            to_json: $$let.to_json,
                                                            from_json_exn: $$let.from_json_exn,
                                                            from_json: $$let.from_json
                                                          })
                                                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                                          [
                                                            11,
                                                            "blocked",
                                                            "blocked"
                                                          ],
                                                          Ocaml_protoc_plugin__Spec.bool,
                                                          false
                                                        ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                                              [
                                                                12,
                                                                "block_reason",
                                                                "blockReason"
                                                              ],
                                                              Ocaml_protoc_plugin__Spec.string,
                                                              ""
                                                            ]), Ocaml_protoc_plugin__Spec.nil))))))))))));
}

const serialize$5 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$5(undefined));
    });

function to_proto$p$5(writer, param) {
  Curry.app(serialize$5, [
        writer,
        param.country,
        param["type'"],
        param.tin,
        param.name,
        param.resident,
        param.address,
        param.chief,
        param.tax,
        param.bank_accounts,
        param.last_update_date,
        param.blocked,
        param.block_reason
      ]);
}

function to_proto$5(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$5(writer, t);
  return writer;
}

function constructor$10(country, type$p, tin, name, resident, address, chief, tax, bank_accounts, last_update_date, blocked, block_reason) {
  return {
          country: country,
          "type'": type$p,
          tin: tin,
          name: name,
          resident: resident,
          address: address,
          chief: chief,
          tax: tax,
          bank_accounts: bank_accounts,
          last_update_date: last_update_date,
          blocked: blocked,
          block_reason: block_reason
        };
}

const from_proto_exn$5 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$5(undefined), constructor$10);
    });

function from_proto$5(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$5, writer);
            });
}

function to_json$5(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.control.v1alpha1.EntityLookupOrg", spec$5(undefined))(options);
  return function (param) {
    return Curry.app(serialize, [
                param.country,
                param["type'"],
                param.tin,
                param.name,
                param.resident,
                param.address,
                param.chief,
                param.tax,
                param.bank_accounts,
                param.last_update_date,
                param.blocked,
                param.block_reason
              ]);
  };
}

function constructor$11(country, type$p, tin, name, resident, address, chief, tax, bank_accounts, last_update_date, blocked, block_reason) {
  return {
          country: country,
          "type'": type$p,
          tin: tin,
          name: name,
          resident: resident,
          address: address,
          chief: chief,
          tax: tax,
          bank_accounts: bank_accounts,
          last_update_date: last_update_date,
          blocked: blocked,
          block_reason: block_reason
        };
}

const from_json_exn$5 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.control.v1alpha1.EntityLookupOrg", spec$5(undefined), constructor$11);
    });

function from_json$5(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$5, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "LookupChief"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "Vat"
              ],
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "LookupTax"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "LookupBankAccount"
        ],
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, EntityLookupOrg, {
      LookupChief: LookupChief,
      LookupTax: LookupTax,
      LookupBankAccount: LookupBankAccount,
      make: make$5,
      to_proto: to_proto$5,
      from_proto: from_proto$5,
      to_json: to_json$5,
      from_json: from_json$5,
      name: name$6,
      merge: merge$5,
      to_proto$p: to_proto$p$5,
      from_proto_exn: from_proto_exn$5,
      from_json_exn: from_json_exn$5
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "to_int"
              ],
              [
                /* Function */0,
                "from_int"
              ],
              [
                /* Function */0,
                "from_int_exn"
              ],
              [
                /* Function */0,
                "to_string"
              ],
              [
                /* Function */0,
                "from_string_exn"
              ]
            ]
          },
          "LookupCtx"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "EntityLookupPerson"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "LookupChief"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "make"
                          ],
                          [
                            /* Function */0,
                            "to_proto"
                          ],
                          [
                            /* Function */0,
                            "from_proto"
                          ],
                          [
                            /* Function */0,
                            "to_json"
                          ],
                          [
                            /* Function */0,
                            "from_json"
                          ],
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "merge"
                          ],
                          [
                            /* Function */0,
                            "to_proto$p"
                          ],
                          [
                            /* Function */0,
                            "from_proto_exn"
                          ],
                          [
                            /* Function */0,
                            "from_json_exn"
                          ]
                        ]
                      },
                      "Vat"
                    ],
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "LookupTax"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "LookupBankAccount"
              ],
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "EntityLookupOrg"
        ]
      ]
    }, V1alpha1, {
      LookupCtx: LookupCtx,
      EntityLookupPerson: EntityLookupPerson,
      EntityLookupOrg: EntityLookupOrg
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "to_int"
                    ],
                    [
                      /* Function */0,
                      "from_int"
                    ],
                    [
                      /* Function */0,
                      "from_int_exn"
                    ],
                    [
                      /* Function */0,
                      "to_string"
                    ],
                    [
                      /* Function */0,
                      "from_string_exn"
                    ]
                  ]
                },
                "LookupCtx"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "EntityLookupPerson"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "make"
                          ],
                          [
                            /* Function */0,
                            "to_proto"
                          ],
                          [
                            /* Function */0,
                            "from_proto"
                          ],
                          [
                            /* Function */0,
                            "to_json"
                          ],
                          [
                            /* Function */0,
                            "from_json"
                          ],
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "merge"
                          ],
                          [
                            /* Function */0,
                            "to_proto$p"
                          ],
                          [
                            /* Function */0,
                            "from_proto_exn"
                          ],
                          [
                            /* Function */0,
                            "from_json_exn"
                          ]
                        ]
                      },
                      "LookupChief"
                    ],
                    [
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            {
                              TAG: /* Module */0,
                              _0: [
                                [
                                  /* Function */0,
                                  "make"
                                ],
                                [
                                  /* Function */0,
                                  "to_proto"
                                ],
                                [
                                  /* Function */0,
                                  "from_proto"
                                ],
                                [
                                  /* Function */0,
                                  "to_json"
                                ],
                                [
                                  /* Function */0,
                                  "from_json"
                                ],
                                [
                                  /* Function */0,
                                  "name"
                                ],
                                [
                                  /* Function */0,
                                  "merge"
                                ],
                                [
                                  /* Function */0,
                                  "to_proto$p"
                                ],
                                [
                                  /* Function */0,
                                  "from_proto_exn"
                                ],
                                [
                                  /* Function */0,
                                  "from_json_exn"
                                ]
                              ]
                            },
                            "Vat"
                          ],
                          [
                            /* Function */0,
                            "make"
                          ],
                          [
                            /* Function */0,
                            "to_proto"
                          ],
                          [
                            /* Function */0,
                            "from_proto"
                          ],
                          [
                            /* Function */0,
                            "to_json"
                          ],
                          [
                            /* Function */0,
                            "from_json"
                          ],
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "merge"
                          ],
                          [
                            /* Function */0,
                            "to_proto$p"
                          ],
                          [
                            /* Function */0,
                            "from_proto_exn"
                          ],
                          [
                            /* Function */0,
                            "from_json_exn"
                          ]
                        ]
                      },
                      "LookupTax"
                    ],
                    [
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "make"
                          ],
                          [
                            /* Function */0,
                            "to_proto"
                          ],
                          [
                            /* Function */0,
                            "from_proto"
                          ],
                          [
                            /* Function */0,
                            "to_json"
                          ],
                          [
                            /* Function */0,
                            "from_json"
                          ],
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "merge"
                          ],
                          [
                            /* Function */0,
                            "to_proto$p"
                          ],
                          [
                            /* Function */0,
                            "from_proto_exn"
                          ],
                          [
                            /* Function */0,
                            "from_json_exn"
                          ]
                        ]
                      },
                      "LookupBankAccount"
                    ],
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "EntityLookupOrg"
              ]
            ]
          },
          "V1alpha1"
        ]]
    }, Control, {
      V1alpha1: V1alpha1
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "to_int"
                          ],
                          [
                            /* Function */0,
                            "from_int"
                          ],
                          [
                            /* Function */0,
                            "from_int_exn"
                          ],
                          [
                            /* Function */0,
                            "to_string"
                          ],
                          [
                            /* Function */0,
                            "from_string_exn"
                          ]
                        ]
                      },
                      "LookupCtx"
                    ],
                    [
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "make"
                          ],
                          [
                            /* Function */0,
                            "to_proto"
                          ],
                          [
                            /* Function */0,
                            "from_proto"
                          ],
                          [
                            /* Function */0,
                            "to_json"
                          ],
                          [
                            /* Function */0,
                            "from_json"
                          ],
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "merge"
                          ],
                          [
                            /* Function */0,
                            "to_proto$p"
                          ],
                          [
                            /* Function */0,
                            "from_proto_exn"
                          ],
                          [
                            /* Function */0,
                            "from_json_exn"
                          ]
                        ]
                      },
                      "EntityLookupPerson"
                    ],
                    [
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            {
                              TAG: /* Module */0,
                              _0: [
                                [
                                  /* Function */0,
                                  "make"
                                ],
                                [
                                  /* Function */0,
                                  "to_proto"
                                ],
                                [
                                  /* Function */0,
                                  "from_proto"
                                ],
                                [
                                  /* Function */0,
                                  "to_json"
                                ],
                                [
                                  /* Function */0,
                                  "from_json"
                                ],
                                [
                                  /* Function */0,
                                  "name"
                                ],
                                [
                                  /* Function */0,
                                  "merge"
                                ],
                                [
                                  /* Function */0,
                                  "to_proto$p"
                                ],
                                [
                                  /* Function */0,
                                  "from_proto_exn"
                                ],
                                [
                                  /* Function */0,
                                  "from_json_exn"
                                ]
                              ]
                            },
                            "LookupChief"
                          ],
                          [
                            {
                              TAG: /* Module */0,
                              _0: [
                                [
                                  {
                                    TAG: /* Module */0,
                                    _0: [
                                      [
                                        /* Function */0,
                                        "make"
                                      ],
                                      [
                                        /* Function */0,
                                        "to_proto"
                                      ],
                                      [
                                        /* Function */0,
                                        "from_proto"
                                      ],
                                      [
                                        /* Function */0,
                                        "to_json"
                                      ],
                                      [
                                        /* Function */0,
                                        "from_json"
                                      ],
                                      [
                                        /* Function */0,
                                        "name"
                                      ],
                                      [
                                        /* Function */0,
                                        "merge"
                                      ],
                                      [
                                        /* Function */0,
                                        "to_proto$p"
                                      ],
                                      [
                                        /* Function */0,
                                        "from_proto_exn"
                                      ],
                                      [
                                        /* Function */0,
                                        "from_json_exn"
                                      ]
                                    ]
                                  },
                                  "Vat"
                                ],
                                [
                                  /* Function */0,
                                  "make"
                                ],
                                [
                                  /* Function */0,
                                  "to_proto"
                                ],
                                [
                                  /* Function */0,
                                  "from_proto"
                                ],
                                [
                                  /* Function */0,
                                  "to_json"
                                ],
                                [
                                  /* Function */0,
                                  "from_json"
                                ],
                                [
                                  /* Function */0,
                                  "name"
                                ],
                                [
                                  /* Function */0,
                                  "merge"
                                ],
                                [
                                  /* Function */0,
                                  "to_proto$p"
                                ],
                                [
                                  /* Function */0,
                                  "from_proto_exn"
                                ],
                                [
                                  /* Function */0,
                                  "from_json_exn"
                                ]
                              ]
                            },
                            "LookupTax"
                          ],
                          [
                            {
                              TAG: /* Module */0,
                              _0: [
                                [
                                  /* Function */0,
                                  "make"
                                ],
                                [
                                  /* Function */0,
                                  "to_proto"
                                ],
                                [
                                  /* Function */0,
                                  "from_proto"
                                ],
                                [
                                  /* Function */0,
                                  "to_json"
                                ],
                                [
                                  /* Function */0,
                                  "from_json"
                                ],
                                [
                                  /* Function */0,
                                  "name"
                                ],
                                [
                                  /* Function */0,
                                  "merge"
                                ],
                                [
                                  /* Function */0,
                                  "to_proto$p"
                                ],
                                [
                                  /* Function */0,
                                  "from_proto_exn"
                                ],
                                [
                                  /* Function */0,
                                  "from_json_exn"
                                ]
                              ]
                            },
                            "LookupBankAccount"
                          ],
                          [
                            /* Function */0,
                            "make"
                          ],
                          [
                            /* Function */0,
                            "to_proto"
                          ],
                          [
                            /* Function */0,
                            "from_proto"
                          ],
                          [
                            /* Function */0,
                            "to_json"
                          ],
                          [
                            /* Function */0,
                            "from_json"
                          ],
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "merge"
                          ],
                          [
                            /* Function */0,
                            "to_proto$p"
                          ],
                          [
                            /* Function */0,
                            "from_proto_exn"
                          ],
                          [
                            /* Function */0,
                            "from_json_exn"
                          ]
                        ]
                      },
                      "EntityLookupOrg"
                    ]
                  ]
                },
                "V1alpha1"
              ]]
          },
          "Control"
        ]]
    }, Buhta, {
      Control: Control
    });

export {
  Imported$pmodules ,
  Buhta ,
}
/* Buhta Not a pure module */
